import React, { lazy } from 'react';
const SuppliersDashboard = lazy(() => import('../containers/Suppliers/SuppliersDashboard'));
function SuppliersRouts() {
    return React.createElement(SuppliersDashboard, null);
}
export default SuppliersRouts;
